var $bc830316669a23f8$exports = {};
$bc830316669a23f8$exports = {
    "loading": `\u{8AAD}\u{307F}\u{8FBC}\u{307F}\u{4E2D}...`,
    "loadingMore": `\u{3055}\u{3089}\u{306B}\u{8AAD}\u{307F}\u{8FBC}\u{307F}\u{4E2D}...`
};


export {$bc830316669a23f8$exports as default};
//# sourceMappingURL=ja-JP.module.js.map
